/**
 * MothNode logo mark. Uses `fill: currentColor` so callers control the color
 * via CSS `color` — keeps the mark theme-aware (brand primary on light,
 * accent on dark, white on the colored login hero).
 */
interface LogoProps {
  className?: string;
  title?: string;
}

export function Logo({ className, title = 'MothNode' }: LogoProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 57.592384"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        transform="translate(0,-111.70526)"
        d="m 27.619792,165.36081 c -0.21563,-3.20366 0.443167,-4.64589 3.536719,-7.73903 2.090955,-2.0911 5.339603,-4.10938 7.219174,-4.48557 1.879582,-0.37563 3.417208,-1.02473 3.417208,-1.44193 0,-1.46616 -6.170912,-5.28243 -15.915268,-9.84376 -15.359581,-7.1899 -23.3675921,-15.13196 -25.48004127,-25.26959 -1.24150322,-5.95804 0.45524166,-6.27921 4.66012217,-0.88197 4.1530812,5.33053 15.3615271,13.4078 23.5632821,16.9801 8.641971,3.76469 14.251765,8.68335 17.16804,15.05335 1.713881,3.74363 3.312867,5.8056 4.380003,5.64917 0.924422,-0.13434 2.860918,-2.79386 4.302928,-5.90689 2.833774,-6.11603 8.584328,-11.10268 17.061406,-14.79563 8.159938,-3.55411 19.402442,-11.63917 23.502349,-16.90162 4.329533,-5.55704 5.660096,-5.43612 4.637184,0.4214 -1.797777,10.2977 -9.745461,18.32548 -25.39584,25.65168 -9.656748,4.52028 -15.915477,8.37662 -15.915477,9.80663 0,0.39719 1.893934,1.28939 4.208398,1.98277 5.620259,1.68436 9.095351,5.61686 9.834845,11.13103 0.607118,4.5267 0.607118,4.5267 -21.956384,4.5267 -22.563599,0 -22.563599,0 -22.828648,-3.93684 z m 13.927309,0.001 c 2.53314,-1.77442 3.336772,-6.44188 1.323462,-7.68612 -3.753281,-2.31967 -12.138605,3.79021 -10.622551,7.74022 0.83434,2.1747 6.161218,2.14353 9.299089,-0.0537 z m 26.081329,-0.003 c 0.984518,-2.56635 -1.005531,-5.50799 -4.786494,-7.07405 -3.949013,-1.63565 -6.695871,-0.86472 -6.672591,1.87248 0.0049,2.5079 1.074571,4.04538 3.84909,5.61851 3.176199,1.80106 6.835714,1.60049 7.609995,-0.41694 z"
      />
    </svg>
  );
}

export default Logo;
